import { render } from "./UnitsLocations.vue?vue&type=template&id=3a31d9b7&scoped=true"
import script from "./UnitsLocations.vue?vue&type=script&lang=js"
export * from "./UnitsLocations.vue?vue&type=script&lang=js"

import "./UnitsLocations.vue?vue&type=style&index=0&id=3a31d9b7&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a31d9b7"]])

export default __exports__